import React, { useReducer, useState } from 'react'
import VolleyballCourt from '../sports/elements/volleyball/VolleyballCourt'
import { thumbStatHandlers, thumbStatInitialState, thumbStatReducer } from './cnr/reducers/ThumbStatReducer'

const ThumbStat = () => {

  const [statComponentType, setStatComponentType] = useState('court')

  const init_state = {}
  const [thumbStat_state, thumbStatDispatch] = useReducer(thumbStatReducer, thumbStatInitialState(init_state));
  const thumbStat_handlers = thumbStatHandlers(thumbStatDispatch)

  const content = () => {
    switch (statComponentType) {
      case 'court':
        return <VolleyballCourt />
    }
  }

  return content()
}

export default ThumbStat